import React from "react";
import "../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
//import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
//import CalendarIcon from '@material-ui/icons/CalendarToday';
//import Button from '@material-ui/core/Button';

//import CloseIcon from '@material-ui/icons/Close';

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ReactTooltip from "react-tooltip";
import * as d3 from "d3";

import {locale}  from '../constants.js'

import YearCalendar from "./yearCalendar";

const styles = (theme) => ({
  progress: {
    margin: theme.spacing() * 2,
  },
  container: {
    textAlign: "left",
    //borderLeft: '3px solid #165469',
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    minHeight: "60",
    maxHeight: "12px",
    /*  
    [theme.breakpoints.up('tablet')]: {
      minHeight: '140px',
      maxHeight: '140px',
    }, [theme.breakpoints.up('md')]: {
      minHeight: '160px',
      maxHeight: '160px',
    },
  */
  },
  /*
  selectorContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px!important",
  },
  */
  dateSelector: {
    //padding: theme.spacing() * 2,
    padding: "25px 20px 0px 20px",
    textAlign: "center",
    fontSize: "1.1em!important",
    fontFamily: "Flanders Art Sans",

    minHeight: "40px",
    height: "40px",
    maxHeight: "40px",
    lineHeight: "20px",
  },
  hoverable: {
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#dbdbdb",
    },
  },
  active: {
    fontWeight: "700!important",
  },
  activeLink: {
    textDecoration: "underline",
    fontWeight: "700!important",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#dbdbdb",
    },
  },
  toolTip: {
    textAlign: "left",
    color: "#165469!important",
    backgroundColor: "#aaaaaa",
    fontFamily: "Flanders Art Sans!important",
  },
});

function DateSelector(props) {
  const { classes } = props;


  

  let currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 6);

  let selectedDate = new Date(currentDate);
  if (props.selectedDate) {
    // time already adjusted in App loadData
    selectedDate = new Date(props.selectedDate);
    //selectedDate.setHours(selectedDate.getHours() + 6);
  }

  if (!props.showCalendar) {
    //let oneWeekAgo = d3.timeDay.offset(selectedDate, -7);
    return (
      <Grid
        container
        item
        xs={12}
        className={classes.container + " darkbluegreen"}
      >
        <Grid
          item
          xs={12}
          style={{ paddingBottom: "20px", paddingLeft: "5px", width: "100%" }}
        >
          Kies een{" "}
          <span
            className={classes.activeLink + " darkbluegreen"}
            onClick={() => props.displayCalendar(true, "realtime")}
          >
            einddatum
          </span>
        </Grid>
      {
      /*
        <Grid item container xs={8} className={classes.dateContainer}>
          <Paper
            className={
              classes.dateSelector + " activeHeaderText bgdarkbluegreen"
            }
          >
            <div>
              {d3.timeFormat("%e %B")(oneWeekAgo)} -
              {d3.timeFormat("%e %B")(selectedDate)}
            </div>
          </Paper>
        </Grid>
      */
      }  
        
      </Grid>
    );
  } 
  else {
    let chosenDate = selectedDate;
    let activeStartDate = chosenDate;
    let minDate = new Date(currentDate);
    minDate.setMonth(currentDate.getMonth() - 3);
    //const maxDate = new Date(new Date().getTime() + 86400000)
    const maxDate = currentDate;

    return (
      <Grid item container xs={12}>
        <Calendar
          activeStartDate={activeStartDate}
          value={chosenDate}
          className="calendar"
          tileClassName="calendar"
          //locale={props.lang === 'de' ? 'de-DE' : (props.lang === 'en' ? 'en-GB' : 'fr-BE')}
          locale="nl"
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value) => props.onDateChange(value)}
        />
      </Grid>
    );
  }
}

DateSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DateSelector);
